const creditsEN = {
  "view": {
      "form": {
          "title": "Order Credits",
          "label": {
            "quantity": "Quantity",
          },
          "placeholder": {
            "quantity": "Select Quantity",
          },
          "help_text": {
            "quantity": "Amount of credits that you want to order.",
          },
          "button": {
            "placeOrder": "Place Order",
          },
          "options": {
            "quantity": {
              "selectQuantity": "Select Quantity",
              "1Credit": "1 Credit",
              "2Credits": "2 Credits",
              "3Credits": "3 Credits",
              "4Credits": "4 Credits",
              "5Credits": "5 Credits",
              "10Credits": "10 Credits",
              "15Credits": "15 Credits",
              "20Credits": "20 Credits",
              "25Credits": "25 Credits",
              "30Credits": "30 Credits",
              "35Credits": "35 Credits",
              "40Credits": "40 Credits",
              "45Credits": "45 Credits",
              "50Credits": "50 Credits",
              "75Credits": "75 Credits",
              "100Credits": "100 Credits",
            },
          },
          "message": {
            "quantityRequired": "Quantity is required",
            "paymentMethodRequired": "Please add a <1>payment method</1> in order to place order for credits.",
            "paymentMethodExpired": "You can not place order for credits as your default <1>payment method</1> has expired, please set a valid payment method as default in order to place order for credits.",
          },
      },
      "modal": {
        "header": "Proceed to checkout",
        "body": {
          "message": "You have ordered {{credits}} Credits",
          "confirmationMessage": "If you want to confirm the order please proceed to checkout, otherwise you can cancel the order.",
        },
        "button": {
          "cancel": "Cancel",
          "checkout": "Checkout"
        }
      },
      "message": {
        "error": "Something went wrong! Please refresh page and try again!"
      }
  },
  "transactionSuccess": {
    "view": {
      "title": "Transaction Successful :)",
      "description": "You have successfully purchased the credits which will be shortly added to your account!",
      "button": {
        "returnToDashboard": "Return to Dashboard",
      }
    }
  },
  "transactionFailure": {
    "view": {
      "title": "Transaction Cancelled :(",
      "description": "The transaction was cancelled... Please try again later!",
      "button": {
        "returnToDashboard": "Return to Dashboard",
      }
    }
  }
};

export default creditsEN;